module.exports = __webpack_public_path__ + "img/shopline.09eaf7d3.png";